import { post } from '../helper/api'
import app_config from '../config/app.json';
const api_url = app_config.api_root + '/api/contact/';

export const reciveData = status => ({
  type: 'RECIVE_DATA',
  payload: { status }
})

export const mailSendSuccess = status => ({
  type: 'SEND_SUCCESS',
  payload: { status }
})

export const sendMail = value => {
  return async (dispatch,getState) => {
    return new Promise((resolve,reject) => {
      post(api_url,value)
      .then((response) => {
        if(response.saccess){
          dispatch(mailSendSuccess(response))
        }
      })
      .then((response) => {
        resolve();
      })
      .catch((e) => {
        console.log("server-error");
        reject();
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/contact.js